import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { UserPermissionsService } from '../services/user-permissions.service';

@Directive({
  selector: '[boiPermissionChecker]'
})
export class PermissionCheckerDirective implements OnInit {
  @Input() boiPermissionChecker: Array<string>;
  @Input() requiresAllPermissions = false;

  constructor(
    private readonly hostElement: ElementRef,
    private readonly userPermissionsService: UserPermissionsService,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (!this.hasRequiredPermissions()) {
      this.renderer.removeChild(this.hostElement.nativeElement.parent, this.hostElement.nativeElement);
    }
  }

  private hasRequiredPermissions(): boolean {
    const userPermissions = this.userPermissionsService.getPermissions();

    return this.requiresAllPermissions
      ? this.boiPermissionChecker.filter((item) => userPermissions.indexOf(item) !== -1).length ===
          this.boiPermissionChecker.length
      : this.boiPermissionChecker.some((item) => userPermissions.indexOf(item) !== -1);
  }
}
